import { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";

import { accessRole } from "../../../constant";
import { createUser, updateUserById } from "../../../../../../actions/customer";

const initData = {
  company: "",
  email: "",
  fullName: "",
  countryCode: 47,
  companyWebsite: "",
  role: "",
  accessLevel: "remediation-mode",
  internalExternalLevel: "",
};

function Index({ orgId, showModal, setShowModal, userData }) {
  const dispatch = useDispatch();
  const [data, setData] = useState({ ...initData });

  useEffect(() => {
    if (userData?._id) {
      setData({ ...userData });
    } else {
      setData({ ...initData });
    }
  }, [userData]);

  const submitForm = async () => {
    try {
      if (data?.company == "") {
        throw new Error("Please enter company name.");
      }
      if (data?.email == "") {
        throw new Error("Please enter email.");
      }
      const EmailRegex =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!EmailRegex.test(data.email)) {
        throw new Error("Please enter valid email id.");
      }
      if (data?.fullName == "") {
        throw new Error("Please enter full name.");
      }
      if (data?.role == "") {
        throw new Error("Please select role.");
      }
      if (data?.internalExternalLevel == "") {
        throw new Error("Please select internal/external value.");
      }
      if (data?._id) {
        updateUserById(
          { ...data, id: data._id, organisationId: orgId },
          dispatch
        );
      } else {
        createUser(
          {
            ...data,
            organisationId: orgId,
            Remediation: true,
          },
          dispatch
        );
      }
      setData({ ...initData });
      setShowModal(false);
    } catch (error) {
      let message = error.message;
      toastr.error("Error", message);
    }
  };

  return (
    <div
      className={`modal fade Form-Wizard-modal ${
        showModal === true ? "d-block show" : ""
      }`}
    >
      <div className="modal-dialog modal-lg" id="clientModal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Add New User
            </h5>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              style={{ backgroundColor: "transparent" }}
              onClick={() => setShowModal(false)}
            >
              <span aria-hidden="true" style={{ color: "#fff" }}>
                ×
              </span>
            </button>
          </div>
          <div className="modal-body pricing_page">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div
                className="card"
                style={{
                  background: "transparent !important",
                }}
              >
                <div className="row clearfix">
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group col-lg-12 col-md-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Company *"
                        value={data.company}
                        onChange={(e) =>
                          setData({
                            ...data,
                            company: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group ol-lg-12 col-md-12">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email *"
                        value={data.email}
                        onChange={(e) =>
                          setData({
                            ...data,
                            email: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group col-lg-12 col-md-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Full Name *"
                        value={data.fullName}
                        onChange={(e) =>
                          setData({
                            ...data,
                            fullName: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="icon-globe"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Company Website"
                          value={data.companyWebsite}
                          onChange={(e) =>
                            setData({
                              ...data,
                              companyWebsite: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group ol-lg-12 col-md-12">
                      <select
                        className="form-control"
                        value={data.role}
                        onChange={(e) =>
                          setData({
                            ...data,
                            role: e.target.value,
                          })
                        }
                      >
                        <option value="">Role / Permission *</option>
                        {accessRole?.map((row) => {
                          return <option value={row.val}>{row.text}</option>;
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group ol-lg-12 col-md-12">
                      <select
                        className="form-control"
                        value={data.internalExternalLevel}
                        onChange={(e) =>
                          setData({
                            ...data,
                            internalExternalLevel: e.target.value,
                          })
                        }
                      >
                        <option value="">Internal / External *</option>
                        <option value="internal">Internal</option>
                        <option value="external">External</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-lg-12 col-md-12"
                    style={{ marginRight: "28px" }}
                  >
                    <button
                      type="button"
                      style={{ color: "black", fontWeight: "bold" }}
                      className="btn btn-round btn-primary mr-1 pull-right"
                      onClick={submitForm}
                    >
                      {userData?._id ? "Update" : "Add"}
                    </button>{" "}
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      onClick={() => setShowModal(false)}
                      className="btn btn-round btn-default pull-right"
                      style={{ marginRight: "10px" }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(Index);
